import styled, { keyframes } from "styled-components";

const initialAnimation = keyframes`
  0% { transform: translateX(1000rem); opacity: 0; }
  100% { transform: translateX(0rem); opacity: 1; }
`;

const finalAnimation = keyframes`
  0% { transform: translateX(0rem); opacity: 1; }
  100% { transform: translateX(1000rem); opacity: 0; }
`;

interface IContainerProps {
  message: string;
}

export const Container = styled.div<IContainerProps>`
  border-radius: 8px;

  animation: ${(props) => (props.message ? initialAnimation : finalAnimation)}
    200ms;

  display: flex;
  justify-content: flex-start;
  align-items: center;

  min-width: 30rem;
  padding-right: 10px;
  height: 4.2rem;

  & em {
    font-family: "Galano";
    font-size: 1.5rem;
    color: #fff;
    text-transform: none;
    font-style: normal;
    font-weight: 600;
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
  }

  background: rgba(215, 69, 69, 0.8);

  img {
    height: 100%;
    padding: 10px;
  }
`;
